import React from 'react';
import styled from 'styled-components';
import { Container } from './Container';

export function Footer() {
  return (
    <StyledFooter>
      <Container fluid>© {new Date().getFullYear()}, Mamas Gun</Container>
    </StyledFooter>
  );
}

const StyledFooter = styled.footer`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  text-align: center;
  color: var(--dark-brown);
  font-size: 0.75rem;
  font-weight: 700;
`;
